import { useSelector } from "react-redux";
import { selectIsOnline } from "../../ducks/app/network/selectors";
import useNetworkListener from "./use-network-listener";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { useTranslation } from "react-i18next";

const NetworkStatusBanner = () => {
  useNetworkListener();
  const { t } = useTranslation("authPage");
  const isOnline = useSelector(selectIsOnline);

  return isOnline ? null : (
    <div
      className="p-4 flex gap-2 justify-center items-center"
      style={{ background: "orange" }}
    >
      <WifiOffIcon />
      <span>{t("offlineError")}</span>
    </div>
  );
};

export default NetworkStatusBanner;
